import React, { useEffect, useState } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, TextField, MenuItem } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { CORP_BLUE } from '../../../config/config';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        backgroundColor: CORP_BLUE,
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: 'white',
            fontWeight: 'bold'
        },

    },
}));



const GestionesExternasModal = (props) => {

    const { closeModal, submitModal, openDialog, showComprobante, folioExterno, loading, setLoading } = props

    const [solicitante, setSolicitante] = useState('')
    const [responsable, setResponsable] = useState('')
    const [queSolicita, setQueSolicita] = useState('')
  
    const [prioridad, setPrioridad] = useState(0)
    const [adjuntos, setAdjuntos] = useState([])
    const [cantDias, setCantDias] = useState(0)
    const [validateForm, setValidateForm] = useState(true)
    const [solicitanteError, setSolicitanteError] = useState('')

    const [queSolicitaError, setQueSolicitaError] = useState('')
    const [responsableError, setResponsableError] = useState('')
    const [prioridadError, setPrioridadError] = useState('')
    const [cantDiasError, setCantDiasError] = useState('')
    const [solicitanteLabel, setSolicitanteLabel] = useState('Solicitante')
    const [queSolicitaLabel, setQueSolicitaLabel] = useState('Qué se solicita')
    const [responsableLabel, setResponsableLabel] = useState('Usuario responsable')
    const [prioridadLabel, setPrioridadLabel] = useState('Prioridad')
    const [cantDiasLabel, setCantDiasLabel] = useState('Cantidad de días de monitoreo')
    const [arch, setArch] = useState([])

    const classes = addStyle();

    useEffect(() => {
        if (validarModal()) {
            setValidateForm(false)
        } else {
            setValidateForm(true)
        }
    }, [solicitante, queSolicita, prioridad, cantDias])

    const handleChangePrioridad = evt => {
        if (evt.target.value === 0) {
            setPrioridadError('Éste campo es requerido.')
            setPrioridadLabel('*Prioridad')
        } else {
            setPrioridadError('')
            setPrioridadLabel('Prioridad')
        }

        setPrioridad(evt.target.value)
    }

    const changeCantDias = evt => {

        if (evt.target.value === 0) {
            setCantDiasError('Éste campo es requerido.')
            setCantDiasLabel('*Cantidad de días de monitoreo')
        } else {
            setCantDiasError('')
            setCantDiasLabel('Cantidad de días de monitoreo')
        }

        setCantDias(evt.target.value)

    }

    const changeQueSolicita = evt => {
        if (evt.target.value !== '') {
            setQueSolicitaLabel('Qué se solicita')
            setQueSolicitaError('')
        }
        setQueSolicita(evt.target.value)
    }

    const changeSolicitante = evt => {
        if (evt.target.value !== '') {
            setSolicitanteLabel('Solicitante')
            setSolicitanteError('')
        }
        setSolicitante(evt.target.value)
    }


    const changeResponsable = evt => {
        if (evt.target.value !== '') {
            setResponsableLabel('Usuario Responsable')

            setResponsableError('')
        }
        setResponsable(evt.target.value)
    }

    const clearData = () => {
        setSolicitante('')
        setResponsable('')
        setQueSolicita('')
        setResponsable('')
        setPrioridad(0)
        setAdjuntos([])
        setArch([])
        setCantDias(0)
        setQueSolicitaError('')
        setSolicitanteError('')
        setCantDiasError('')
        setPrioridadError('')
        setSolicitanteLabel('Solicitante')
        setQueSolicitaLabel('Qué se solicita')
        setPrioridadLabel('Prioridad')
        setCantDiasLabel('Cantidad de días de monitoreo')
    }

    const onCloseDialog = () => {
        clearData()
        closeModal()
    }

    const onSubmitClick = () => {
        setLoading(true)
        let data = {
            usuario_solicitante: solicitante,
            usuario_responsable: responsable, 
            prioridad: prioridad,
            solicitud: queSolicita,
            usuario_responsable:responsable,
            dias: cantDias,
            files: arch
        }
        
        submitModal(data)
        //onCloseDialog()
    };

    const getStyle = () => {
        if (validateForm) {

        } else {
            return { backgroundColor: CORP_BLUE, color: 'white' }
        }
    }

    const validarModal = () => {
        if (solicitante === '' || queSolicita === '' || prioridad === 0 || cantDias === 0 || cantDias === '') {
            return false
        } else {
            return true
        }
    }

    const getUploadParams = ({ meta }) => {
        return { url: 'https://httpbin.org/post' };
    };

    const handleChangeStatus = ({ meta, file }, status) => {

        if (status === 'done') {

            let aux2 = []

            arch.map((item, index) => {
                aux2.push(item)
            })

            const fileReader = new FileReader();

            fileReader.onload = (fileR) => {

                let data = fileR.target.result.split(',')[1]
                /* aux2.push({ data: data, fileName: file.name }) */
                aux2.push({ data: fileR.target.result, fileName: file.name })

            };

            fileReader.readAsDataURL(file);
            setArch(aux2)


        }
        if (status === 'removed') {

            let aux = []
            arch.map((item, index) => {
                aux.push(item)
            })
            let indice = aux.findIndex(e => e.fileName === file.name)
            aux.splice(indice, 1)
            setArch(aux)
        }

    };


    return (

        <Dialog open={openDialog} onClose={onCloseDialog} maxWidth='sm' fullWidth>
            <DialogTitle className={classes.dialogTitleRoot}> {'Solicitud Externa'} </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }} hidden={!showComprobante}>
                    <Grid container spacing={2}>

                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label={solicitanteLabel}
                                value={solicitante}
                                onChange={changeSolicitante}
                                onBlur={() => {
                                    if (solicitante === '') {
                                        setSolicitanteError('Éste campo es requerido.')
                                        setSolicitanteLabel('*Solicitante')
                                    } else {
                                        setSolicitanteError('')
                                        setSolicitanteLabel('Solicitante')
                                    }

                                }}
                                error={solicitanteError}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                name="select_prioridad"
                                fullWidth
                                select
                                variant="outlined"
                                label={prioridadLabel}
                                value={prioridad}
                                onChange={handleChangePrioridad}
                                onBlur={() => {

                                }}
                                error={prioridadError}
                            >
                                <MenuItem key={0} value={0}>Seleccione</MenuItem>
                                <MenuItem key={10} value={1}>Alta</MenuItem>
                                <MenuItem key={20} value={2}>Media</MenuItem>
                                <MenuItem key={30} value={3}>Baja</MenuItem>
                            </TextField>
                        </Grid>
                       
                    </Grid>
                </Box>

                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }} hidden={!showComprobante}>
                    <Grid container spacing={2}>

                    <Grid item xs={6}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label={responsableLabel}
                                value={responsable}
                                onChange={changeResponsable}
                                onBlur={() => {
                                    if (responsable === '') {
                                        setResponsableError('Éste campo es requerido.')
                                        setResponsableLabel('*Usuario responsable')
                                    } else {
                                        setResponsableError('')
                                        setResponsableLabel('Usuario responsable')
                                    }

                                }}
                                error={responsableError}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            {/*                             <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="Cantidad de días"
                                    value={cantDias}
                                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    onChange={changeCantDias}
                                    onBlur={() => {
                                        if (cantDias === 0 || cantDias === '') {
                                            setCantDiasError('Éste campo es requerido.')
                                        } else {
                                            setCantDiasError('')
                                        }

                                    }}
                                    error={cantDiasError}
                                /> */}
                            <TextField
                                name="select_dias"
                                fullWidth
                                select
                                variant="outlined"
                                label={cantDiasLabel}
                                value={cantDias}
                                onChange={changeCantDias}
                                onBlur={() => {

                                }}
                                error={cantDiasError}
                            >
                                <MenuItem key={0} value={0}>Seleccione</MenuItem>
                                <MenuItem key={1} value={5}>5</MenuItem>
                                <MenuItem key={2} value={10}>10</MenuItem>
                                <MenuItem key={3} value={15}>15</MenuItem>
                                <MenuItem key={4} value={20}>20</MenuItem>
                                <MenuItem key={5} value={25}>25</MenuItem>
                                <MenuItem key={6} value={30}>30</MenuItem>
                            </TextField>
                        </Grid>
                        

                    </Grid>
                </Box>

                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }} hidden={!showComprobante}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                style={{ width: '100%' }}
                                rows={2}
                                variant="outlined"
                                multiline
                                label={queSolicitaLabel}
                                value={queSolicita}
                                onChange={changeQueSolicita}
                                onBlur={() => {
                                    if (queSolicita === '') {
                                        setQueSolicitaError('Éste campo es requerido.')
                                        setQueSolicitaLabel('*Qué se solicita')
                                    } else {
                                        setQueSolicitaError('')
                                        setQueSolicitaLabel('Qué se solicita')
                                    }

                                }}
                                error={queSolicitaError}

                            />
                        </Grid>

                    </Grid>
                </Box>

                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }} hidden={!showComprobante}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Dropzone
                                styles={{
                                    dropzone: { overflow: 'hidden' },
                                    dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
                                    inputLabel: (files, extra) => (extra.reject ? { color: 'red' } : {}),
                                }}
                                getUploadParams={getUploadParams}
                                onChangeStatus={handleChangeStatus}
                                /*   onSubmit={handleSubmit} */
                                inputWithFilesContent={'Subir mas'}
                                accept="image/*,.pdf,.PDF"
                                inputContent={(files, extra) => (extra.reject ? 'Image, audio and video files only' : 'Arrastre archivos o haga click aquí')}
                                canRestart={true}
                                minSizeBytes={10}


                            />
                        </Grid>
                        <Grid item xs={12}>
                            <p>Solo archivos de imagen o pdf</p>
                        </Grid>

                    </Grid>
                </Box>

                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }} hidden={showComprobante}>
                    <Grid item xs={12} >
                        <h2 style={{ color: 'rgb(0, 0, 0)', fontSize: 16, padding: 10 }}>

                            <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', padding: 10, marginBottom: 50 }}>Su solicitud ha sido ingresada con el siguiente número de folio:  {folioExterno}</h3>
                        </h2>
                    </Grid>
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} variant='contained' disabled={loading} hidden={!showComprobante}>
                        Cerrar
                    </Button>
                    <Box ml={2}>

                        <Button disabled={validateForm} variant="contained" style={getStyle()} onClick={() => {
                            if (!showComprobante) {
                                onCloseDialog()
                            } else {
                                if (validarModal()) {
                                    onSubmitClick()
                                } else {
                                    setValidateForm(true)
                                }
                            }

                        }}>
                            {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Aceptar'}
                        </Button>


                    </Box>
                </Box>
            </DialogContent>
        </Dialog>

    );
};

export default GestionesExternasModal;